import {Component,ElementRef,EventEmitter,Output,ViewChild,} from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { OAuthService } from "angular-oauth2-oidc";
import { ToastrService } from "ngx-toastr";
import { first } from "rxjs/operators";
import { RSAHelper } from "src/app/_helpers/RSAHelper";
import { UserTypeEnum } from "src/app/_models";
import { Claims } from "src/app/_models/common/claims";
import {UserRequestBase,Userrequestdto,} from "src/app/_models/user/userrequestdto";
import { AuthenticationService } from "src/app/_services";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { VersionHistoryService } from "src/app/_services/common/version-history.service";
import { CookieService } from "ngx-cookie-service";
import { UpToDateBuildService } from "../../../up-to-date.service";
import { environment } from "src/environments/environment";
import { ConvertNonAsciiToAscii } from "src/app/common/commonvariables";
import { MfaPopupComponent } from './mfa-popup/mfa-popup.component'; 
import { ButtonComponent } from '../../../shared/design-system/button/button.component';
import { TextboxComponent } from '../../../shared/design-system/textbox/textbox.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { RecaptchaModule } from 'ng-recaptcha';
import { CheckboxComponent } from '../../../shared/design-system/checkbox/checkbox.component';
import { CheckboxConfig } from '../../../shared/design-system/checkbox/checkbox.modal';
import { TextboxConfig } from "../../../shared/design-system/textbox/textbox.modal";
import { ButtonConfig } from "../../../shared/design-system/button/button.modal";
import { EMAIL_REGEX } from "src/util/constants";
import { ApplicationSettingService } from "src/app/_services/application-setting/application-setting.service";
@Component({
    selector: "app-login-new",
    templateUrl: "./login-new.component.html",
    standalone: true,
    imports: [
      CommonModule,
      ButtonComponent,
      TextboxComponent,
      TranslateModule,
      MfaPopupComponent,
      FormsModule,
      ReactiveFormsModule,
      RecaptchaModule,
      CheckboxComponent
    ]
})
export class LoginNewComponent  {
  params: any;
  submitted = false;
  claims: Claims;
  showCaptcha = false;
  caprchaResult = "";
  disableLoginButton = true;
  rsaHelper: RSAHelper;
  userrequest: UserRequestBase;
  registrationsubmitted = false;
  isOnboardingProcessComplete = false;
  showCaptchaMessage = false;
  referralCode: string = "";
  /** Free-preview trial length (days), resolved from application settings ("TrialDays") via API. */
  trialDays: number = 1;
  impersonate: string = "";
  cookieValue: string = "";
  claimValue: string = "";
  impersonationResponse: any;
  impersonationUserClaim: any;
  loading = false;
  username: string = '';
  password: string = '';
  rememberpassword: boolean = false;
  rememberMeCheckboxConfig: CheckboxConfig = {
    isDisabled: true,
    isSelected: false,
    label: '',
    ariaLabel: 'remember-me-checkbox',
    size: 'md'
  };
  emailValidationMessage: string = '';
  passwordValidationMessage: string = '';
  qrSecret: string = "";
  invalidCaptcha: string = "";
  siteKey = '6LeyHFcrAAAAABx8PkWD5oxtTmjqIpAa1LUUqHae';
  otp1: number = 0;
  otp2: number = 0;
  otp3: number = 0;
  otp4: number = 0;
  otp5: number = 0;
  otp6: number = 0;
  OTP: number = 0;
  userrequestdto: Userrequestdto;
  showMailOTPBox = false;
  showAuthenticatorBox = false;
  userLoginResponse: any;
  isOTPModelOpen = false;
  isMFADeviceRewgistered = false;
  showPasswordBox = false;
  emailConfig!: TextboxConfig;
  passwordConfig!: TextboxConfig;
  buttonConfig!: ButtonConfig;

  @Output() gotoNextStepEvent = new EventEmitter<any>();
  token: string | undefined;
  @ViewChild('captchaRef') captchaRef: any;
  @ViewChild('mfaPopup') mfaPopup!: MfaPopupComponent;
  @ViewChild("emailField") emailField!: ElementRef<HTMLInputElement>;
  @ViewChild("passwordField") passwordField!: ElementRef<HTMLInputElement>;
  constructor(
    private translate: TranslateService,
    private claimsService: ClaimsService,
    private authenticationService: AuthenticationService,
    private oauthService: OAuthService,
    private meta: Meta,
    private title: Title,
    private router: Router,
    private versionHistoryService: VersionHistoryService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private cookieService: CookieService,
    private upToDateService: UpToDateBuildService,
    private applicationSettingService: ApplicationSettingService,
  ) {
    this.token = undefined;
    this.userrequest = new UserRequestBase();

    upToDateService.pollForBuildNumber().subscribe((buildIsUpToDate) => {
      if (this.upToDateService.buildNumberAtStartup !== buildIsUpToDate.buildNumber)
        window.location.reload();
    });
  }

  /** Resolve the free-preview trial length ("TrialDays") from application settings via API. */
  getTrialDays(): void {
    this.applicationSettingService.GetTrialDays().subscribe((res: any) => {
      if (res?.responseInfo) {
        this.trialDays = Number(res.responseInfo);
      }
    });
  }

  

  ngOnInit(): void {
    setTimeout(() => {
      this.title.setTitle("Customer Login");
      this.meta.updateTag({
        name: "description",
        content: this.translate.instant("meta_tag_login_description"),
      });
    }, 1000);
    
    this.configEmailAndPassword();
    this.configLogin();
    this.getTrialDays();
    this.authenticationService.logout();
    this.authenticationService.loadAccessToken();
    this.SetRememberPassword();
    this.authenticationService.loadAccessToken();
    this.fnCheckRouteParams();
    this.params = this.route.snapshot.queryParams;
    var paramKeys = Object.keys(this.params);
    if (paramKeys.length > 0) {
      this.referralCode = this.params.referralCode;
      this.impersonate = this.params.impersonate;
      this.getUserImprosonated();
    }
  }

  SetRememberPassword() {
    if (localStorage.getItem("rememberpassword") && localStorage.getItem("username")) {
      this.username = localStorage.getItem("username") || '';
      this.password = localStorage.getItem("rememberpassword") || '';
      this.rememberpassword = true;
    }
    this.updateRememberCheckboxConfig();
  }

  onRememberChanged(checked: boolean) {
    this.rememberpassword = checked;
    this.rememberMeCheckboxConfig.isSelected = checked;
  }

  configLogin() {
    this.translate.get(['login','login_button_aria_label']).subscribe(trans => {
      this.buttonConfig = {
        id: 'login-button',
        label: trans['login'],
        color: "primary",
        size: "lg",
        block: true,
        disabled: !this.username || !this.password,
        ariaLabel: trans['login_button_aria_label']
      };
    });
  }
  configEmailAndPassword(){
    this.translate.get(['email_label','email_placeholder','password','password_placeholder']).subscribe(trans => {
      this.emailConfig = {
        id: 'email-input',
        label: trans['email_label'],
        placeholder: trans['email_placeholder'],
        value: this.username,
        type: 'email',
        isInvalid: !!this.emailValidationMessage,
        helperText: this.emailValidationMessage,
        size: 'lg',
        maxLength: null,
      };
      this.passwordConfig = {
        id: 'password-input',
        label: trans['password'],
        type: 'password',
        value: this.password,
        isInvalid: !!this.passwordValidationMessage,
        helperText: this.passwordValidationMessage,
        size: 'lg',
        placeholder: trans['password_placeholder'],
      };
    });
  }

  onEmailChange(val: string) {
    this.username = val;
    this.emailConfig = {
      ...this.emailConfig,
      value: val,
      isInvalid: !!this.emailValidationMessage,
      helperText: this.emailValidationMessage,
    };
    this.configLogin();
    this.updateRememberCheckboxConfig();
  }

  onPasswordChange(val: string) {
    this.password = val;
    this.passwordConfig = {
      ...this.passwordConfig,
      value: val,
      isInvalid: !!this.passwordValidationMessage,
      helperText: this.passwordValidationMessage,
    };    
    this.configLogin();
  }

  updateRememberCheckboxConfig() {
    this.translate.get('remember_me').subscribe(trans => {
    this.rememberMeCheckboxConfig = {
      isDisabled: this.username === '',
      isSelected: this.rememberpassword,
      label: trans,
      ariaLabel: 'remember-me-checkbox',
      size: 'md'
    };
  });
  }

  fnCheckRouteParams() {
    let params = this.route.snapshot.queryParams;
    var paramKeys = Object.keys(params);
    if (paramKeys.length > 0 && params["code"]) {
      this.authenticationService.getXeroUserDetails(params["code"]).subscribe(
        (userData: any) => {
          const token = userData.idToken;
          localStorage.setItem("signupxerotoken", token);
          this.gotoSignUp();
        },
        (error: any) => {
        }
      );
    }
  }

  getUserImprosonated() {
    this.claims = new Claims();
    try {
      if (this.impersonate) {
        localStorage.clear();
        this.cookieValue = this.cookieService.get("UserIdentity");
        if (this.cookieValue == "") {
          this.router.navigate(["/login"]);
        } else {
          this.claimValue = this.cookieService.get("AdditionalUserClaim");
          localStorage.setItem("currentUser", this.cookieValue);
          localStorage.setItem("currentUserTemp", this.cookieValue);
          this.impersonationResponse = JSON.parse(this.cookieValue);
          this.oauthService.tokenEndpoint = environment.token_endpoint;
          this.oauthService
          .fetchTokenUsingPasswordFlowAndLoadUserProfile(
            this.impersonationResponse.EmailId,
            "testpassword"
          )
          .then(() => {
            localStorage.setItem(
              "loginToken",
              this.impersonationResponse.Token
            );
            localStorage.setItem(
              "refresh_token",
              this.impersonationResponse.RefreshToken
            );
            localStorage.setItem(
              "access_token",
              this.impersonationResponse.Token
            );

            var tokenNew = this.oauthService.getAccessToken();
            this.claims.OrgId = this.impersonationResponse.OrganisationId;
            this.claims.EmailId = this.impersonationResponse.EmailId;
            this.claims.UserId = this.impersonationResponse.UserId;
            this.claims.CurrentOrganisationCurrency = this.impersonationResponse.CurrentOrganisationCurrency;
            this.claims.CurrentOrganisationCurrencyId = this.impersonationResponse.CurrentOrganisationCurrencyId;
            if (this.impersonationResponse.CurrentOrganisationCurrency) {
              this.claims.CurrentOrganisationCurrencyCode = this.impersonationResponse.CurrentOrganisationCurrency.split("-")[1].trim();
              this.claims.CurrentOrganisationCurrency = this.impersonationResponse.CurrentOrganisationCurrency.split("-")[1].trim();
            }
            this.claims.FinanceManager = ConvertNonAsciiToAscii.removeAccents(this.impersonationResponse.FirstName) +
              " " + ConvertNonAsciiToAscii.removeAccents(this.impersonationResponse.LastName);
            this.claims.LoginId = this.impersonationResponse.EmailId;
            this.claims.IsFinanceManager = this.impersonationResponse.IsFinanceManager;
            this.claims.Token = tokenNew;
            this.claims.FMRoleType = this.impersonationResponse.FMRoleType;
            this.claims.UserHomeCurrencyId = this.impersonationResponse.UserHomeCurrencyId;
            this.claims.UserHomeCurrencyCode = this.impersonationResponse.UserHomeCurrencyCode;
            this.claims.UserHomeCurrencyName = this.impersonationResponse.UserHomeCurrencyName;
            this.claims.IsDelegator = this.impersonationResponse.IsDelegator;
            this.claims.IsDelegate = this.impersonationResponse.IsDelegate;
            this.claims.IsContainerEnabled = this.impersonationResponse.IsContainerEnabled;
            this.impersonationUserClaim = JSON.parse(this.claimValue);
            this.claims.OrgLogo = "assets/images/logo.png";
            this.claims.OrgName = this.impersonationUserClaim.Name;
            this.claims.TwoStepApproval = this.impersonationUserClaim.TwoStepApproval;
            this.claims.IsCardSetupComplete = this.impersonationUserClaim.IsCardSetupComplete;
            this.claims.accountingSystemId = this.impersonationUserClaim.AccountingSystemId;
            this.claims.accountingSystemType = this.impersonationUserClaim.AccountingSystemType;
            this.claims.IsOrgBasicFunctionTrialEndsReminder = this.impersonationUserClaim.IsOrgBasicFunctionTrialEndsReminder;
            this.claims.IsOrgBasicFunctionTrialEndsAlert = this.impersonationUserClaim.IsOrgBasicFunctionTrialEndsAlert;
            this.claims.ReferAndEarnRole = this.impersonationUserClaim.ReferAndEarnRole;
            this.claims.CompanyApproverRule = this.impersonationUserClaim.CompanyApproverRule;
            this.claims.isClaimOnWebAllowed = this.impersonationUserClaim.IsClaimOnWebAllowed;
            this.claims.IsFromOrgLogin = false;
            this.claims.ApprovalRuleSetting = this.impersonationUserClaim.ApprovalRuleSetting;
            this.claims.orgRoleId = this.impersonationUserClaim.RoleId;
            this.claims.showCostCentresWithoutApproverCount = true;
            this.claims.showOfficeLocationsExpiredAlert = true;
            this.claims.IsCashAdvanceEnabled = this.impersonationUserClaim.IsCashAdvanceEnabled;
            this.claims.IsCreditCardAdvanceEnabled = this.impersonationUserClaim.IsCreditCardAdvanceEnabled;
            this.claims.triangulationRule = this.impersonationUserClaim.TriangulationRule;
            this.claims.isPolicyOnVehicleChange = this.impersonationUserClaim.IsPolicyOnVehicleChange;
            this.claims.isUniversalImportAllowed = this.impersonationUserClaim.IsUniversalImportAllowed;
            this.claims.IsAPAutomationAllow = this.impersonationUserClaim.IsAPAutomationAllow;
            this.claims.IsDelegateFunctionPurchasedOrTrial = this.impersonationUserClaim.IsDelegateFunctionPurchasedOrTrial;
            this.claims.isStripPaymentFailed = this.impersonationUserClaim.IsStripPaymentFailed;
            this.claims.RateType = this.impersonationUserClaim.RateType;
            this.claims.nrfcStatus = this.impersonationUserClaim.NRFCStatus;
            this.claims.isNRPackagePurchasedOrTrial = this.impersonationUserClaim.IsNRPackagePurchasedOrTrial;
            this.claims.isFCPackagePurchasedOrTrial = this.impersonationUserClaim.IsFCPackagePurchasedOrTrial;
            this.claims.userType = this.impersonationUserClaim.UserType ?? 0;
            this.claims.BandId = this.impersonationUserClaim.BandId;
            this.claims.BandPlanId = this.impersonationUserClaim.BandPlanId;
            this.claims.BillingCycle = this.impersonationResponse.BillingCycle;
            this.claims.IsPayStepEnabled = this.impersonationUserClaim.IsPayStepEnabled;
            this.claims.IsContainerEnabled = this.impersonationResponse.IsContainerEnabled;
            this.claims.IsContainerPurchasedOrTrial = this.impersonationUserClaim.IsContainerPurchasedOrTrial;
            this.claims.IsCfpEnabled = this.impersonationResponse.IsCarbonFootPrintEnabled;
            this.claims.IsContainerAllowed = this.impersonationUserClaim.IsContainerAllowed;
            this.claims.PreApprovalEnabled = this.impersonationUserClaim.PreApprovalEnabled ?? false;
            this.claims.HasTemporaryUnsubscribed = this.impersonationUserClaim.HasTemporaryUnsubscribed;
            this.claims.minDeputyRequiredPerUser = this.impersonationUserClaim.MinDeputyRequiredPerUser;
            this.claims.isDeputySetupOn = this.impersonationUserClaim.IsDeputySetupOn;
            this.claims.isManualVatOn = this.impersonationUserClaim.IsManualVatOn;
            this.claims.isTaxRateOn = this.impersonationUserClaim.IsTaxRateOn;
            this.claims.isFmEditExpenseOn = this.impersonationUserClaim.IsFmEditExpenseOn;
            this.claims.isCostCentreOn = this.impersonationUserClaim.IsCostCentreOn;
                  this.claims.isCustomerOn =
                  this.impersonationUserClaim.IsCustomerOn;
            this.claims.IsMultipleCompaniesPackagePurchasedOrTrial = this.impersonationUserClaim.IsMultipleCompaniesPackagePurchasedOrTrial;
            this.claims.RequisitionApprovalRuleType = this.impersonationUserClaim.RequisitionApprovalRuleType;
            this.claims.IsLocationPurchasedOrTrial = this.impersonationUserClaim.isLocationPackagePurchasedOrTrial;            
            this.claims.IsSelfSetupOn = this.impersonationUserClaim.IsSelfSetupOn;
            this.claims.SelfSetupPercentage = this.impersonationUserClaim.SelfSetupPercentage;
            this.claims.isBasicFunctionPurchased =  this.impersonationUserClaim.IsBasicFunctionPurchased;
            localStorage.setItem("istokenImpersonated", "true");
            this.claimsService.updateClaims(this.claims);
            this.cookieService.delete(
              "UserIdentity",
              "/",
              "expenseondemand.com",
              true
            );
            this.cookieService.delete(
              "AdditionalUserClaim",
              "/",
              "expenseondemand.com",
              true
            );
            this.title.setTitle("ExpenseOnDemand");
            this.bindClaimsFromOrgDetails({responseInfo: { userId: this.impersonationResponse.UserId, emailId: this.impersonationResponse.EmailId, token: this.impersonationResponse.Token } });
          })
          .catch((err) => {
            this.disableLoginButton = false;
            console.error("error logging in", err);
          });
        }
      }
    } catch (Exception) {
      this.router.navigate(["/login"]);
      this.cookieService.delete(
        "UserIdentity",
        "/",
        "expenseondemand.com",
        true
      );
      this.cookieService.delete(
        "AdditionalUserClaim",
        "/",
        "expenseondemand.com",
        true
      );
      this.loading = false;
    }
  }

  onEmailIdEntered() {
    if (this.username != "") {
      this.emailValidationMessage = "";
      this.emailConfig = {
        ...this.emailConfig,
        isInvalid: false,
        helperText: this.emailValidationMessage,
      };
      var domain = this.username.split("@").pop();
      this.authenticationService.checkDomainEnabledForSSO(domain).subscribe(
        (userData: any) => {
          if (userData.responseInfo.isDomainEnabled) {            
            this.emailValidationMessage = this.translate.instant('please_enter_valid_email_address');
            this.emailConfig = {
              ...this.emailConfig,
              isInvalid: true,
              helperText: this.emailValidationMessage,
            };
            localStorage.setItem("isfromorglogin", "true");
            this.router.navigate(["/orglogin"]);
            return;
          } else {
            this.showPasswordBox = this.username != "" && true;
            setTimeout(() => {
              if (this.showPasswordBox) {
                this.passwordField.nativeElement.focus();
              }
            }, 200);
          }
        },
        (error: any) => {
          console.error("Error checking domain for SSO", error);
        }
      );
    }
  }

  onLoginSubmit() {
    if (!this.username || !this.password) {
      return;
    }
    this.claims = new Claims();
    this.submitted = true;
    this.registrationsubmitted = false;
    if (!EMAIL_REGEX.test(this.username)) {
      this.emailValidationMessage = this.translate.instant('label_Emailisnotvalid');
      this.emailConfig = {
        ...this.emailConfig,
        isInvalid: true,
        helperText: this.emailValidationMessage,
      };
      return;
    }
    this.emailValidationMessage = "";
    this.emailConfig = {
      ...this.emailConfig,
      isInvalid: false,
      helperText: this.emailValidationMessage,
    };
    if (this.showCaptcha && this.caprchaResult == "") {
      return;
    }

    this.translate.getTranslation(this.translate.getBrowserLang() || 'en');
    this.disableLoginButton = true;
    this.rsaHelper = new RSAHelper();
    this.userrequest.RequestInfo = new Userrequestdto();
    this.userrequest.WebApiName = "SoloLogin";
    this.userrequest.WebApiVersion = 1;
    this.userrequest.RequestId = "111";
    this.userrequest.RequestInfo.LoginId = this.username;
    this.userrequest.RequestInfo.Password = this.rsaHelper.Encrypt(
      this.password
    );
    if (this.rememberpassword) {
      this.claims.LoginId = this.userrequest.RequestInfo.LoginId;
      this.claims.Password = this.userrequest.RequestInfo.Password;
      localStorage.setItem("rememberpassword", this.password);
      localStorage.setItem("username", this.username);
    } else {
      localStorage.removeItem("rememberpassword");
      localStorage.removeItem("username");
    }
    this.authenticationService.login(this.userrequest).subscribe(
      (data: any) => {
        if (data.statusCode == 0) {
          this.userLoginResponse = data;
          if (data.responseInfo.isMFAEnabled) {
            if (data.responseInfo.isMFADeviceRegistered) {
              this.isMFADeviceRewgistered = true;
              this.showAuthenticatorBox = true;
              this.showMailOTPBox = false;
              this.qrSecret = data.responseInfo.mfaSecret;
              if (this.mfaPopup) {
                this.mfaPopup.handleMFAResponse(data);
              }
            } else {
              this.isMFADeviceRewgistered = false;
              this.registerMFADevice();
            }

            this.otp1 = this.otp2 = this.otp3 = this.otp4 = this.otp5 = this.otp6 = 0;
            return;
          } else {
            this.continueLogin();
          }
        } else {
          this.toastr.error(data.errorInfo[0].message, '', {
            timeOut: 15000
          });
          this.checkForCaptchaVisibility();
        }
      },
      (error: any) => {
        this.disableLoginButton = false;
        this.toastr.error(error, '', {
          timeOut: 15000
        });
      }
    );
  }

  bindVersionHistory() {
    if (!this.claims.appVersion) {
      this.versionHistoryService.getVersionHistory().subscribe((res: any) => {
        if (res.statusCode == 0) {
          let currentVersion = res.responseInfo.filter(
            (x: any) => x.isCurrentRelease
          )[0].versionNumber;

          this.claims.appVersion = currentVersion;
          this.claimsService.updateClaims(this.claims);
        }
      });
    }
  }

  routeUser() {
    // A pending Pliant connection (Pliant redirected the admin to /pliant-connect,
    // which stashed its params before showing this login) takes priority over
    // role-based navigation.
    if (sessionStorage.getItem("pliantConnectParams")) {
      this.router.navigate(["/pliant-connect"], { queryParams: { resume: 1 } });
      return;
    }
    if (this.claims.IsFinanceManager == true){
        if(this.claims.HasTemporaryUnsubscribed){
          this.router.navigate(["/settings"]);
        }
        else{
          if(this.claims.isBasicFunctionPurchased && this.claims.IsSelfSetupOn && this.claims.SelfSetupPercentage !== 100){
            this.router.navigate(["/self-setup"]);
          }
          else{
           this.router.navigate([""]);
          }
        }
    }
    else {
      if (this.claims.orgRoleId == UserTypeEnum.Approver) {
        this.router.navigate(["/approver/appclaimant"]);
      } else {
        if (
          this.claims.IsDelegateFunctionPurchasedOrTrial &&
          this.claims.IsDelegate
        ) {
          this.router.navigate(["claimant/delegatorsexpense"]);
        } else {
          this.router.navigate(["claimant/expenselist"]);
        }
      }
    }
  }

  gotoSignUp() {
    this.router.navigate(["register"]);
  }

  ngAfterViewInit() {
    this.emailField.nativeElement.focus();
  }

  verifyOTPandLogin() {
      
    this.continueLogin();
  }

  registerMFADevice() {
    if (this.mfaPopup) {
      this.mfaPopup.registerMFADevice();
    }
  }

  continueLogin() {
    let data = this.userLoginResponse;
    this.oauthService
      .fetchTokenUsingPasswordFlowAndLoadUserProfile(
        data.responseInfo.emailId,
        this.rsaHelper.Encrypt(this.password)
      )
      .then(() => {
        localStorage.removeItem("isfromorglogin");

        this.title.setTitle("ExpenseOnDemand");

        sessionStorage.removeItem("CurrentUserLoginAttempt");
        sessionStorage.removeItem("CurrentUserTriedLogin");
        localStorage.setItem("showComplianceStatement", "1");
        localStorage.setItem("showCcTransactionsAlert", "1");
        var tokenNew = this.oauthService.getAccessToken();
        this.claims.IsFromOrgLogin = false;
        this.claims.OrgId = data.responseInfo.organisationId;
        this.claims.IsMFAEnabled = data.responseInfo.isMFAEnabled;
        this.claims.IsMFADeviceRegistered =
          data.responseInfo.isMFADeviceRegistered;
        this.claims.EmailId = data.responseInfo.emailId;
        this.claims.UserId = data.responseInfo.userId;
        this.claims.supplierRule = data.responseInfo.supplierRule;
        this.claims.showCompliancePopup =
          data.responseInfo.showComplianceStatement;
        this.claims.complianceHeader = data.responseInfo.complianceHeader;
        this.claims.complianceStatement = data.responseInfo.complianceStatement;
        this.claims.CurrentOrganisationCurrency =
          data.responseInfo.currentOrganisationCurrency;
        this.claims.CurrentOrganisationCurrencyId =
          data.responseInfo.currentOrganisationCurrencyId;
        if (data.responseInfo.currentOrganisationCurrency) {
          this.claims.CurrentOrganisationCurrencyCode =
            data.responseInfo.currentOrganisationCurrency.split("-")[1].trim();
        }
        this.claims.FinanceManager =
          ConvertNonAsciiToAscii.removeAccents(data.responseInfo.firstName) +
          " " +
          ConvertNonAsciiToAscii.removeAccents(data.responseInfo.lastName);
        this.claims.LoginId = data.responseInfo.emailId;
        this.claims.IsFinanceManager = data.responseInfo.isFinanceManager;
        this.claims.IsMarqueeOn = data.responseInfo.isMarqueeOn;
        this.claims.IsAPAutomationAllow = data.responseInfo.isAPAutomationAllow;
        this.claims.MarqueeText = data.responseInfo.marqueeText;
        this.isOnboardingProcessComplete = data.responseInfo.isOnboardingProcessComplete;
        this.claims.userType = data.responseInfo.userType ?? 0;
        this.claims.kycStatus = data.responseInfo.kycStatus;
        this.claims.docStatus = data.responseInfo.docStatus;
        this.claims.IsKYCMandatoryForInvoice =
          data.responseInfo.isKYCMandatoryForInvoice;
        this.claims.Token = tokenNew;
        this.claims.FMRoleType = data.responseInfo.fmRoleType;
        this.claims.isClaimOnWebAllowed = data.responseInfo.isClaimOnWebAllowed;
        this.claims.orgRoleId = data.responseInfo.orgRoleId;
        this.claims.IsLeaveManagementAllowed =
          data.responseInfo.isLeaveManagementAllowed;
        this.claims.IsTravelCategoryAllowed =
          data.responseInfo.isTravelCategoryAllowed;
        this.claims.ApprovalRuleSetting = data.responseInfo.approvalRuleSetting;
        this.claims.showCostCentresWithoutApproverCount = true;
        this.claims.showOfficeLocationsExpiredAlert = true;
        this.claims.isUniversalImportAllowed =
          data.responseInfo.isUniversalImportAllowed;
        this.claims.IsAPAutomationAllow = data.responseInfo.isAPAutomationAllow;

        this.claims.UserHomeCurrencyId = data.responseInfo.userHomeCurrencyId;
        this.claims.UserHomeCurrencyCode =
          data.responseInfo.userHomeCurrencyCode;
        this.claims.UserHomeCurrencyName =
          data.responseInfo.userHomeCurrencyName;
        this.claims.IsDelegator = data.responseInfo.isDelegator;
        this.claims.IsDelegate = data.responseInfo.isDelegate;
        this.claims.isMultiAccSysIntAllow =
          data && data.responseInfo && data.responseInfo.isMultiAccSysIntAllow
            ? data.responseInfo.isMultiAccSysIntAllow
            : false;
        this.claims.IsContainerAllowed = data.responseInfo.isContainerAllowed;
        this.claimsService.updateClaims(this.claims);
        this.attemptStoreCredentials();
        this.bindVersionHistory();
        if (!data.responseInfo.isOnboardingProcessComplete) {
          // Password is already set; resume onboarding at organisation details (no organisation exists yet).
          this.claims.FMRoleType = 1;
          this.claims.orgRoleId = UserTypeEnum.FinanceManager;
          this.claimsService.updateClaims(this.claims);
          this.gotoNextStepEvent.emit(5);
          return;
        }
        this.bindClaimsFromOrgDetails(data);
      })
      .catch((err) => {
        this.disableLoginButton = false;
        console.error("error logging in", err);
      });
  }

  attemptStoreCredentials() {
      const nav: any = (navigator as any);
      const PW = (window as any).PasswordCredential;
      if (nav && nav.credentials && PW && this.username && this.password) {
          const cred = new PW({ id: this.username, password: this.password });
          nav.credentials.store(cred).catch((err: any) => {
            this.storeCredentialsFallback();
          });
      }
  }

  storeCredentialsFallback() {
      const form = document.createElement('form');
      document.body.appendChild(form);
      form.submit();
  }

  checkForCaptchaVisibility() {
    var loginAttemptCount = 0;

    if (sessionStorage.getItem("CurrentUserTriedLogin")) {
      if (
        sessionStorage.getItem("CurrentUserTriedLogin") != this.username
      ) {
        sessionStorage.setItem("CurrentUserLoginAttempt", "0");
      }
    }

    if (sessionStorage.getItem("CurrentUserLoginAttempt")) {
      loginAttemptCount =
        Number(sessionStorage.getItem("CurrentUserLoginAttempt")) + 1;
    } else {
      loginAttemptCount = 1;
    }
    sessionStorage.setItem(
      "CurrentUserLoginAttempt",
      loginAttemptCount.toString()
    );
    sessionStorage.setItem("CurrentUserTriedLogin", this.username);
    if(loginAttemptCount > 0 && loginAttemptCount < 10){
      this.invalidCaptcha = this.translate.instant('invalid_captcha_text');
      this.showCaptchaMessage = true;
    }
    else if(loginAttemptCount >=10){
      this.showCaptcha = true;
      this.showCaptchaMessage = true;      
      this.invalidCaptcha = this.translate.instant('captcha_required_after_10_attempts');
    }    
  }

  onCaptchaResolved(token: string) {
    this.caprchaResult = token;
    console.log('Captcha token:', token);
  }

  bindClaimsFromOrgDetails(data){
    this.authenticationService
          .organisationdetails(
            data.responseInfo.userId.toString(),
            data.responseInfo.emailId,
            data.responseInfo.token
          )
          .pipe(first())
          .subscribe(
            (orgData: any) => {
              if (orgData.statusCode == 0) {
                if (orgData.responseInfo[0].icon !== null) {
                  if (orgData.responseInfo[0].icon == "") {
                    this.claims.OrgLogo = "assets/images/logo.png";
                  } else {
                    this.claims.OrgLogo =
                      "data:image/jpeg;base64," + orgData.responseInfo[0].icon;
                  }
                }
                this.claims.RateType = orgData.responseInfo[0].rateType;
                this.claims.nrfcStatus = orgData.responseInfo[0].nrfcStatus;
                this.claims.OrgName = orgData.responseInfo[0].name;
                this.claims.TwoStepApproval =
                  orgData.responseInfo[0].twoStepApproval;
                this.claims.IsCardSetupComplete =
                  orgData.responseInfo[0].isCardSetupComplete;
                this.claims.accountingSystemId =
                  orgData.responseInfo[0].accountingSystemId;
                this.claims.accountingSystemType =
                  orgData.responseInfo[0].accountingSystemType;
                this.claims.showGooglePackagePurchaseReminder =
                  orgData.responseInfo[0].showGooglePackagePurchaseReminder;
                this.claims.googlePackagePurchaseReminderThreshold =
                  orgData.responseInfo[0].googlePackagePurchaseReminderThreshold;
                this.claims.IsOrgBasicFunctionTrialEndsReminder =
                  orgData.responseInfo[0].isOrgBasicFunctionTrialEndsReminder;
                this.claims.IsOrgBasicFunctionTrialEndsAlert =
                  orgData.responseInfo[0].isOrgBasicFunctionTrialEndsAlert;

                this.claims.IsLeaveManagementAllowed =
                  orgData.responseInfo[0].isLeaveManagementAllowed;
                this.claims.IsTravelCategoryAllowed =
                  orgData.responseInfo[0].isTravelCategoryAllowed;
                this.claims.ApprovalRuleSetting =
                  orgData.responseInfo[0].approvalRuleSetting;
                this.claims.IsCostCentrePackagePurchasedOrTrial =
                  orgData.responseInfo[0].isCostCentrePackagePurchasedOrTrial;
                this.claims.IsCustomerPackagePurchasedOrTrial =
                  orgData.responseInfo[0].isCustomerPackagePurchasedOrTrial;
                this.claims.ReferAndEarnRole =
                  orgData.responseInfo[0].referAndEarnRole;
                this.claims.CompanyApproverRule =
                  orgData.responseInfo[0].companyApproverRule;
                this.claims.IsClaimantWiseMonthlyCappingEnabled =
                  orgData.responseInfo[0].isClaimantWiseMonthlyCappingEnabled;
                this.claims.IsClaimantWiseYearlyCappingEnabled =
                  orgData.responseInfo[0].isClaimantWiseYearlyCappingEnabled;

                this.claims.isUniversalImportAllowed =
                  orgData.responseInfo[0].isUniversalImportAllowed;
                this.claims.IsAPAutomationAllow =
                  orgData.responseInfo[0].isAPAutomationAllowed;
                this.claims.IsCashAdvanceEnabled =
                  orgData.responseInfo[0].isCashAdvanceEnabled;
                this.claims.IsCreditCardAdvanceEnabled =
                  orgData.responseInfo[0].isCreditCardAdvanceEnabled;
                this.claims.isMultiAccSysIntAllow =
                  orgData &&
                    orgData.responseInfo[0] &&
                    orgData.responseInfo[0].isMultiAccSysIntAllow
                    ? orgData.responseInfo[0].isMultiAccSysIntAllow
                    : false;
                this.claims.isPolicyOnVehicleChange =
                  orgData.responseInfo[0].isPolicyOnVehicleChange;
                this.claims.triangulationRule =
                  orgData.responseInfo[0].triangulationRule;
                this.claims.isStripPaymentFailed =
                  orgData.responseInfo[0].isStripPaymentFailed;
                this.claims.IsDelegateFunctionPurchasedOrTrial =
                  orgData.responseInfo[0].isDelegateFunctionPurchasedOrTrial;
                this.claims.isDocRequired =
                  orgData.responseInfo[0].isDocRequired;
                this.claims.BandId = orgData.responseInfo[0].bandId;
                this.claims.BandPlanId = orgData.responseInfo[0].bandPlanId;
                this.claims.BillingCycle = orgData.responseInfo[0].billingCycle;
                this.claims.IsPayStepEnabled =
                  orgData.responseInfo[0].isPayStepEnabled;
                this.claims.IsAPAutomationAllow =
                  orgData.responseInfo[0].isAPAutomationAllowed;
                this.claims.isNRPackagePurchasedOrTrial =
                  orgData.responseInfo[0].isNRPackagePurchasedOrTrial;
                this.claims.isFCPackagePurchasedOrTrial =
                  orgData.responseInfo[0].isFCPackagePurchasedOrTrial;
                this.claims.IsContainerEnabled =
                  orgData.responseInfo[0].isContainerEnabled;
                this.claims.IsContainerPurchasedOrTrial =
                  orgData.responseInfo[0].isContainerPurchasedOrTrial;
                this.claims.IsContainerAllowed =
                  orgData.responseInfo[0].isContainerAllowed;
                this.claims.PreApprovalEnabled =
                  orgData.responseInfo[0].preApprovalEnabled;
                this.claims.IsCfpEnabled =
                  orgData.responseInfo[0].isCarbonFootPrintEnabled;
                this.claims.HasTemporaryUnsubscribed =
                  orgData.responseInfo[0].hasTemporaryUnsubscribed;
                  this.claims.minDeputyRequiredPerUser =
                  orgData.responseInfo[0].minDeputyRequiredPerUser;
                  this.claims.isDeputySetupOn =
                  orgData.responseInfo[0].isDeputySetupOn;
                  this.claims.isManualVatOn =
                  orgData.responseInfo[0].isManualVatOn;
                  this.claims.isTaxRateOn =
                  orgData.responseInfo[0].isTaxRateOn;
                  this.claims.isFmEditExpenseOn =
                  orgData.responseInfo[0].isFmEditExpenseOn;
                  this.claims.isCostCentreOn =
                  orgData.responseInfo[0].isCostCentreOn;
                  this.claims.isCustomerOn =
                  orgData.responseInfo[0].isCustomerOn;
                this.claims.IsMultipleCompaniesPackagePurchasedOrTrial = orgData.responseInfo[0].isMultipleCompaniesPackagePurchasedOrTrial;
                this.claims.isPreApprovalPurchased = orgData.responseInfo[0].isPreApprovalPurchased;
                this.claims.RequisitionApprovalRuleType =
                  orgData.responseInfo[0].requisitionApprovalRuleType;
                  this.claims.CanCreateRequisition = orgData.responseInfo[0].canCreateRequisition;
                this.claims.IsLocationPurchasedOrTrial = orgData.responseInfo[0].isLocationPackagePurchasedOrTrial;
                this.claims.IsSelfSetupOn = orgData.responseInfo[0].isSelfSetupOn;
                this.claims.SelfSetupPercentage = orgData.responseInfo[0].selfSetupPercentage;
                this.claims.isBasicFunctionPurchased = orgData.responseInfo[0].isBasicFunctionPurchased;
                this.claims.IsPurchaseOrderPending = orgData.responseInfo[0].isPurchaseOrderPending;
                this.claims.IsDemoBooked = orgData.responseInfo[0].isDemoBooked;
                this.claimsService.updateClaims(this.claims);
                this.authenticationService.setloginnav();
                this.toastr.clear();
                this.routeUser();
              }
            },
            (error: any) => {
              this.disableLoginButton = false;
            }
          );
  }
}
